/**
 * Pages:
 * - /business/placement-of-funds-and-securities
 * - /core/plugins/getMetaParamsForPage.js
 */
export const bannerRate = '18';

/**
 * Pages:
 * - /business/placement-of-funds-and-securities
 */
export const classic = {
    title: 'Депозит «Классический»',
    shortTitle: '«Классический»',
    percent: '18',
};

export const urgent = {
    title: 'Депозит Срочный',
    shortTitle: 'Срочный',
    percent: '17,8',
};

export const minimumBalance = {
    title: 'Депозит С неснижаемым остатком',
    shortTitle: 'С неснижаемым остатком',
    percent: '15',
};

export const comfort = {
    title: 'Депозит Комфортный',
    shortTitle: 'Комфортный',
    percent: '18',
};
